import { render, staticRenderFns } from "./AllWallet.vue?vue&type=template&id=2521b580&scoped=true"
import script from "./AllWallet.vue?vue&type=script&lang=js"
export * from "./AllWallet.vue?vue&type=script&lang=js"
import style0 from "./AllWallet.vue?vue&type=style&index=0&id=2521b580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2521b580",
  null
  
)

export default component.exports